export class ApplicationError extends Error {
  public code: number;

  public constructor(message?: string, code: number = 500) {
    super(message);
    this.code = code;
  }
}

export class NotFoundError extends ApplicationError {
  public constructor(message: string = "Does not exist") {
    super(message, 404);
  }
}

export class OrganizationNotFoundError extends ApplicationError {
  public constructor() {
    super("Organization does not exist", 404);
  }
}

export class PermissionDeniedError extends ApplicationError {
  public constructor() {
    super("Insufficent permission", 401);
  }
}

export class MissingSearchParameterError extends ApplicationError {
  public constructor() {
    super("Missing search parameter", 404);
  }
}

export class StripeError extends ApplicationError {
  public constructor() {
    super("Stripe payment error", 500);
  }
}
